/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DnR API
 * 地方自治体事業管理システムAPI
 * OpenAPI spec version: 1.0.0
 */

import type { RequestHandlerOptions } from 'msw';
import { delay, HttpResponse, http } from 'msw';

import type { TenantsOptionsResponse } from './model';

export const getGetTenantsOptionsResponseMock = (): TenantsOptionsResponse => ({
  divisions: [
    { id: '00000001-0000-0000-0000-000000000001', code: 'D001', name: '総務課', year: 2025 },
    { id: '00000002-0000-0000-0000-000000000002', code: 'D002', name: '企画課', year: 2025 },
  ],
  roles: [
    { code: 'admin', name: '管理者' },
    { code: 'editor', name: '編集者' },
  ],
});

export const getGetTenantsOptionsMockHandler = (
  overrideResponse?:
    | TenantsOptionsResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<TenantsOptionsResponse> | TenantsOptionsResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/tenants/options',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetTenantsOptionsResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};
export const getDnRAPIMock = () => [getGetTenantsOptionsMockHandler()];
